import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/news";
import { formatViews, getCategoryName } from "@/utils/news";

interface HotRankingProps {
  items: NewsItem[];
}

export default function HotRanking({ items }: HotRankingProps) {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5">
      <ul className="divide-y divide-background-200">
        {items.map((item, idx) => {
          const rank = idx + 1;
          const isTop = rank <= 3;
          return (
            <li key={item.id}>
              <Link to={`/detail/${item.id}`} className="flex items-start gap-3 py-3 group cursor-pointer">
                <span
                  className={`shrink-0 w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold ${
                    isTop ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {rank}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </p>
                  <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-400">
                    <span className="text-secondary-700">{getCategoryName(item.categoryId)}</span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-fire-line" />
                      {formatViews(item.views)}
                    </span>
                  </div>
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}